import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../SliderAbout/SliderAbout.scss';
import '../SliderAbout/SliderAbout.scss';
import sliderImage1 from '../../components/img/bg a.jpeg';
import sliderImage2 from '../../components/img/bg c.jpeg';

const AboutSlider = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    fade: true,
    arrows: true,
    adaptiveHeight: true,
    pauseOnHover: true,
  };

  return (
    <div className="about-slider">
      <div className="slider-container">
        <Slider {...sliderSettings}>
          <div className="relative">
            <img
              src={sliderImage1}
              alt="Slide 1"
              className="w-full h-auto rounded-lg shadow-md"
            />
            <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
              <div className="text-center">
                <Link
                  to="/"
                  className="text-white text-xl bg-blue-500 px-4 py-2 rounded hover:bg-blue-700 transition"
                >
                  Home
                </Link>
                <Link
                  to="/About"
                  className="text-white text-xl bg-green-500 px-4 py-2 rounded ml-4 hover:bg-green-700 transition"
                >
                  About
                </Link>
              </div>
            </div>
          </div>
          <div className="relative">
            <img
              src={sliderImage2}
              alt="Slide 2"
              className="w-full h-auto rounded-lg shadow-md"
            />
            <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
              <div className="text-center">
                <Link
                  to="/"
                  className="text-white text-xl bg-blue-500 px-4 py-2 rounded hover:bg-blue-700 transition"
                >
                  Home
                </Link>
                <Link
                  to="/contact"
                  className="text-white text-xl bg-green-500 px-4 py-2 rounded ml-4 hover:bg-green-700 transition"
                >
                  Contact
                </Link>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default AboutSlider;